/* eslint-disable no-unused-vars */
export enum GeogatingType {
    STANDARD = 'Standard',
    EXTENTED = 'Extended',
    UNGEOGATED = 'None'
}

export enum GeogatingMode {
    CLASSICAL = 'Classical',
    UNGEOGATED = 'Ungeogated',
}
